import { NodeModel } from "../_model/NodeModel";
import { DecorationDistillationColumnB } from "./decorationDistillationColumnB";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class DistillationColumnB extends NodeModel {
  constructor() {
    super("DistillationColumnB");

    this.type = new Types().DistillationColumnB;

    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 140;
    this.width = 60;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/colunaDestilacaoB.png");
    this.data = [new Properties({ ...this })];
    this.jokerCaption = [];

    this.decorate = async function(callback) {
      this.decorator = new DecorationDistillationColumnB();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new DistillationColumnB();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.readOnly = this.readOnly
      cloned.expressionVisible = this.expressionVisible;
      cloned.jokerCaption = this.jokerCaption
      cloned.data = this.data.map((d) => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.jokerCaption = node.jokerCaption
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;

      }
      this.jokerCaption = node.jokerCaption
    };
  }
}

export { DistillationColumnB };
